<template>
  <div class="wrapper">
    <div class="full-img-wrap" v-if="showFullImg" @click="showFullImg = false">
      <img class="full-img" :src="item.header_img" alt />
    </div>
    <div v-else class="xBox Pos-r">
      <img
        v-if="item.apply_status === '更新岗位'"
        class="Pos-a success-img"
        src="@/assets/images/apply_success.png"
      />
      <div class="offline-title" v-if="item.type === 1">
        <div class="title">{{ item.title }}</div>
        <div class="time">{{ item.start_time }} 至 {{ item.end_time }}</div>
        <div class="mark">
          <div>参与企业 {{ item.companies_count }}家</div>
          <div>岗位数量 {{ item.jobs_count }}个</div>
        </div>
      </div>

      <div class="form">
        <div v-if="item.type === 0">
          <img class="banner" :src="item.banner" />
        </div>
        <div v-if="item.type === 0">
          <div class="key">招聘会名称：</div>
          <div class="value">{{ item.title }}</div>
        </div>
        <div v-if="item.address">
          <div class="key">招聘会地址：</div>
          <div class="value">{{ item.address_name }}</div>
        </div>
        <div v-if="item.contact">
          <div class="key">招聘会负责人：</div>
          <div class="value">{{ item.contact }}</div>
        </div>
        <div v-if="item.contact_phone">
          <div class="key">招聘会负责人电话：</div>
          <div class="value">{{ item.contact_phone }}</div>
        </div>
        <div>
          <div class="key">开始时间：</div>
          <div class="value">{{ item.start_time }}</div>
        </div>
        <div>
          <div class="key">结束时间：</div>
          <div class="value">{{ item.end_time }}</div>
        </div>
        <div v-if="item.max_company_num">
          <div class="key">参与企业数上限：</div>
          <div class="value">{{ item.max_company_num }}</div>
        </div>
        <div>
          <div class="key">报名开始时间：</div>
          <div class="value">{{ item.apply_start_time }}</div>
        </div>
        <div>
          <div class="key">报名结束时间：</div>
          <div class="value">{{ item.apply_end_time }}</div>
        </div>
        <div v-if="item.description">
          <div class="key">简介：</div>
          <div class="value" v-html="item.description"></div>
        </div>
      </div>
      <div class="btn" v-if="item.apply_status === 1" @click="setList">立即报名</div>
      <div class="btn" v-else-if="item.apply_status === '更新岗位'" @click="setList">更新岗位</div>
      <div class="btn" style="color:#999;background:#ccc" v-else>{{ item.apply_status }}</div>
      <Modal
        v-model="baoming"
        :closable="false"
        :mask-closable="false"
        ok-text="提交"
        @on-ok="ok"
        @on-cancel="baoming = false"
        width="400"
      >
        <div class="huodong">
          <div class="title">活动时间</div>
          <div class="time">{{ item.start_time }} 至 {{ item.end_time }}</div>
          <div class="list">
            <div class="item" v-for="(item,index) in list" :key="index">
              <div>
                <div class="key">岗位选择:</div>
                <div class="value" @click="setZhiwei">{{list[index]['job']['name']}}</div>
                <!-- <i @click="del(index)" class="iconfont icon-jianshao"></i> -->
              </div>
              <div v-if="zhiweiType == 1">
                <div class="key">招聘人数:</div>
                <Select v-model="list[index]['headcount']" style="width:200px">
                  <Option v-for="item in peopleNumber" :value="item" :key="item">{{ item }}</Option>
                </Select>
                <!-- <i @click="del(index)" class="iconfont icon-jianshao"></i> -->
              </div>
            </div>
            <i @click="setZhiwei" class="iconfont icon-bianzu77"></i>
          </div>
        </div>
      </Modal>
      <Modal
        v-model="zhiwei"
        title="岗位"
        :closable="false"
        :mask-closable="false"
        @on-ok="zhiweiok"
        @on-cancel="zhiwei = false"
        width="400"
      >
        <div class="zhiwei">
          <CheckboxGroup v-model="zhiweiIndex" @on-change="zhiweiChange">
            <div class="item" v-for="(item,index) in cityList" :key="index">
              <Checkbox :label="item.id">
                <div>
                  <div class="title">{{item.name}}</div>
                  <div class="text">{{item.short_description}}</div>
                </div>
              </Checkbox>
            </div>
          </CheckboxGroup>
          <!-- <RadioGroup v-model="zhiweiIndex">
            <div class="item" v-for="(item,index) in cityList" :key="index">
              <Radio :label="index">
                <div>
                  <div class="title">{{item.name}}</div>
                  <div class="text">{{item.short_description}}</div>
                </div>
              </Radio>
            </div>
          </RadioGroup>-->
        </div>
      </Modal>
      <Modal
        v-model="jujue"
        :closable="false"
        :mask-closable="false"
        @on-ok="baoming = true"
        width="400"
        ok-text="重新报名"
      >
        <div>{{ item.title }}招聘会报名失效</div>
      </Modal>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      zhiwei: false,
      id: null,
      zhiweiType: null,
      baoming: false,
      list: [],
      item: {},
      cityList: [],
      peopleNumber: [],
      zhiweiIndex: [],
      baomingIndex: null,
      jujue: false,
      showFullImg: false
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getData();
    this.getList();
    this.setPeople();
    this.setJob();
  },
  methods: {
    getData() {
      this.$axios
        .request({
          url: "api/qiye/jobfairs/" + this.id,
          method: "get"
        })
        .then(res => {
          this.item = res.data;
          this.zhiweiType = this.item.type;
          if (this.item.apply_status == "申请被拒") {
            this.jujue = true;
          }
          if (this.item.type == 0 && this.item.header_img) {
            this.showFullImg = true;
          }
        });
    },
    getList() {
      this.$axios
        .request({
          url: "api/qiye/jobfairs/getJobs/" + this.id,
          method: "get"
        })
        .then(res => {
          this.list = res.data;
          this.list.map(item => {
            this.zhiweiIndex.push(item.jobId);
          });
        });
    },
    setPeople() {
      for (let i = 1; i <= 2000; i++) {
        this.peopleNumber.push(i);
      }
    },
    setJob() {
      this.$axios
        .request({
          url: "api/qiye/job/list?allData=1",
          method: "get"
        })
        .then(res => {
          this.cityList = res.data;
        });
    },
    setList() {
      this.baoming = true;
    },
    setZhiwei(index) {
      // this.baomingIndex = index;
      this.zhiwei = true;
    },
    add() {
      this.list.push({ job: {} });
    },
    del(index) {
      this.list.splice(index, 1);
    },
    ok() {
      if (!this.item.id) {
        return;
      }
      let flag = false;
      if(!this.list || this.list.length == 0){
        this.$Notice.error({
          title: "岗位不能为空"
        });
        flag = true;
      }
      this.list.map(item => {
        if (!item.job.name) {
          this.$Notice.error({
            title: "岗位不能为空"
          });
          flag = true;
        }
      });
      if (flag) return;
      this.$axios
        .request({
          url: "api/qiye/jobfairs/join/" + this.item.id,
          method: "post"
        })
        .then(res => {
          if (res.success) {
            this.$axios
              .request({
                url: "api/qiye/jobfairs/updateJobs/" + this.item.id,
                method: "post",
                data: {
                  jobs: this.list
                }
              })
              .then(res => {
                let mes = "报名成功";
                if (this.item.apply_status === "更新岗位") {
                  mes = "更新成功";
                }
                this.$Notice.success({
                  title: mes
                });
                setTimeout(() => {
                  this.$router.back(-1);
                }, 1000);
              });
          }
        });
    },
    zhiweiChange(e) {
      this.zhiweiIndex = e;
    },
    zhiweiok() {
      let list = [];
      //遍历拿出选中的job
      this.zhiweiIndex.map(id => {
        this.cityList.map(item => {
          if (item.id == id) {
            list.push({ job: { ...item } });
          }
        });
      });
      //判断是线上还是线下
      if (this.zhiweiType == 0) {
        //线上直接赋值
        this.list = list;
      } else if (this.zhiweiType == 1) {
        //线下考虑到已选人数做兼容
        let arr = [];
        if (this.list.length > 0) {

          //遍历现选岗位和历史岗位作对比
          list.map(item => {
            let key = true;
            this.list.map(item1 => {
                //相同的用历史岗位
              if (item.job.id == item1.job.id) {
                key = false;
                arr.push(item1);
              }
            });
            //不相同的重新添加进已选岗位
            if (key) {
              arr.push(item);
            }
          });
          this.list = [...arr];
        } else {
          this.list = [...list];
        }
      }
      // this.list[this.baomingIndex]["job"] = {
      //   ...this.cityList[this.zhiweiIndex]
      // };
      // console.log(this.baomingIndex);
      // this.$forceUpdate();
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ivu-checkbox-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  > .ivu-checkbox {
    margin-right: 10px;
  }
}
.wrapper {
  background: #fff;
  padding-bottom: 126px;
  .xBox {
    width: 500px;
    margin: 0 auto;
    color: #363e4f;
    font-size: 14px;
     .title {
      padding-top: 40px;
      font-size: 16px;
      font-weight: bold;
    }
    .time {
      padding-top: 10px;
    }
     .mark {
      display: flex;
      padding-top: 10px;
      > div {
        padding: 2px 5px;
        color: #d6000f;
        background: #f0f6ff;
        margin-right: 5px;
      }
    }
    .form {
      padding-top: 10px;
      > div {
        margin-top: 34px;
        display: flex;
        > .key {
          white-space: nowrap;
        }
        > .value {
          margin-left: 8px;
        }
      }
    }
    .btn {
      width: 102px;
      height: 36px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      float: right;
      margin-top: 30px;
      background: #d6000f;
      cursor: pointer;
    }
  }
}
/deep/ .ivu-modal-body {
  .huodong {
    .title {
      color: #363e4f;
      font-size: 18px;
    }
    .time {
      color: #363e4f;
      font-size: 14px;
      margin-top: 10px;
    }
    .list {
      padding-bottom: 10px;
      max-height: 300px;
      overflow-y: scroll;
      > .item {
        > div {
          margin-top: 20px;
          display: flex;
          align-items: center;
          > .key {
            margin-right: 10px;
            white-space: nowrap;
          }
          > .value {
            width: 200px;
            height: 30px;
            line-height: 30px;
            padding-left: 8px;
            box-sizing: border-box;
            border: 1px solid #dcdee2;
            border-radius: 4px;
            cursor: pointer;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          > .iconfont {
            font-size: 25px;
            margin-left: 10px;
            cursor: pointer;
          }
        }
      }
      .iconfont {
        cursor: pointer;
      }
    }
  }
  .zhiwei {
  }
}
/deep/ .ivu-radio-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.success-img {
  width: 80px;
  right: 0;
  top: 50px;
}
.banner {
  width: 200px;
  height: auto;
}
.full-img-wrap {
  padding: 20px 0;
  text-align: center;
  cursor: pointer;
}
.full-img {
  width: 500px;
  height: auto;
}
</style>